/**
 * # ejemplo de url https://static.massimodutti.net/3/cms/config/config-ES.json
 * # Servicio para recoger la configuración del nuevo CMS  
 */
 (function () {
    'use strict';

    angular
        .module('itxApp.common')
        .factory('CmsConfigSvc', cmsConfigService);

    cmsConfigService.$inject = [
        '$q', 
        '$http',
        'timestampSvc',
        'ItxConfigurationSvc',
        'DUTTI_CONS',
        'CommonServices',
        'preCommonCmsConfigSvc'
    ];
    
    function cmsConfigService(
        $q, 
        $http,  
        timestampSvc,
        ItxConfigurationSvc,
        DUTTI_CONS,
        CommonServices,
        preCommonCmsConfigSvc
    ) {

        var _this = this;
        _this.isPending = false;
        _this.promise;
        let deferTranslation;
        _this.cmsConfigPath = ItxConfigurationSvc.getCmsStaticPath() +'/config';
        _this.cmsLangPath = ItxConfigurationSvc.getCmsStaticPath() +'/lang';
        //_this.cmsContentPath = ItxConfigurationSvc.getCmsStaticPath() +'/contents';
        _this.cmsApiPath =  ItxConfigurationSvc.getCmsApiPath() ;
        _getTranslateJSON();

        var service = {
            getProperty: preCommonCmsConfigSvc.getProperty,
            getTranslateJSON: _getTranslateJSON,
            getSynchronousTranslateJson: _getSynchronousTranslateJson,
            getTranslation: _getTranslation,
            getSynchronousTranslation: _getSynchronousTranslation,
            getProperties: _getProperties,
            getConfigCms: preCommonCmsConfigSvc.getConfigCms,
            resetJsonCache:_resetJsonCache,
            getConfigCmsPage: _getConfigCmsPage,
            isCmsPage: _isCmsPage,
            waitTranslations:_waitTranslations,
            replaceParamsOnTranslation: _replaceParamsOnTranslation
        };
        return service;



        // Get configuraciones directamente de la API (no se puede usar en PRO todavia)
        // function _getPropertyApi (key) {
            // var deferred = $q.defer();
            // var request = new XMLHttpRequest();
            // const url = _getCmsApiPath + '/config/' + inditex.iCountryCode + '?keys=' + key;
            // request.open('GET', url, true);
            // request.setRequestHeader('Content-Type', 'application/json');
            // request.onload = function() {
            //     if (request.status >= 200 && request.status < 400) {
            //         deferred.resolve(request.response);
            //     } else {
            //         deferred.resolve(false);
            //     }
            // };
            // request.onerror = function() {
            //     deferred.resolve(false);
            // };
            // request.send();
            // return deferred.promise;
        //}



        function  _resetJsonCache(){
            _this.JsonCacheConf = null;
            _this.isPending = false;
        }

        function _waitTranslations(){
            if(!deferTranslation){
                deferTranslation = $q.defer();
            }
            return deferTranslation.promise;
        }

        function _getTranslateJSON() {
            if(!deferTranslation){
                deferTranslation = $q.defer();
                if(inditex.translationsLegacy){
                    _this.JsonCacheTranslation = inditex.translationsLegacy;
                }
                if(inditex && inditex.iCountryCode && inditex.iLangId && !_this.JsonCacheTranslation){
                    var langValue = DUTTI_CONS.i_languages[inditex.iLangId].toLowerCase();
                    
                    if (langValue === 'ga'){
                        langValue = 'gl'; //Me obligaron a hacer esto
                    }
                    if (langValue === 'in'){
                        langValue = 'id'; //Me obligaron a hacer esto
                    }
                    if (langValue === 'iw') {
                        langValue = 'he';
                    }
                    if (langValue.indexOf('-') != -1) {
                        langValue = langValue.split('-')[0];
                    }
                    var url; 
                    if ( ItxConfigurationSvc.useCmsApi()){
                            url =_this.cmsApiPath + '/translations/' + inditex.iCountryCode + '/' + langValue+'?device=webApp&tags=dev';
                    }
                    else{
                        var url = _this.cmsLangPath +'/'+ inditex.iCountryCode + '-' + langValue + '.json' + '?' + timestampSvc.getTs();
                    }
                    return $http.get(url)
                    .then(function (res) {
                        _this.JsonCacheTranslation = res.data;
                            deferTranslation.resolve(_this.JsonCacheTranslation);
                    })
                    .catch(function (err) {
                        console.error(err);
                            deferTranslation.reject(err);
                    });
                } else if(_this.JsonCacheTranslation) {
                        deferTranslation.resolve(_this.JsonCacheTranslation);
                } else {
                    console.error('Estamos solicitando el Json de traducciones del CMS sin tener Inditex Cargado');
                        deferTranslation.reject('Inditex no está cargado, debes esperar a que este cargado para realizar la petición');
                    } 
            } 
            return deferTranslation.promise;
        }

        function _getSynchronousTranslateJson(){
            return _this.JsonCacheTranslation;
        }

        function _getTranslation(key,params) {
            var deferred = $q.defer();
            if(!key){
                deferred.reject('ERROR Tienes que enviar parametro STRING');
            } else {
                return _getTranslateJSON().then(function () {
                    return _getSynchronousTranslation(key,params);
                });
            }
            return deferred.promise;
        }

        function _getSynchronousTranslation(key,params){
            var value = null;
            var jsonTranslate = service.getSynchronousTranslateJson();
            
            if(jsonTranslate){
                value = jsonTranslate[key];
                if(value === undefined){
                    value = '???'+key+'???';
                } else {
                    if(value === '.'){
                        value = '';
                    }
                    if(params && params.length > 0){
                        value = _replaceParamsOnTranslation(value,params);
                    }
                }
            }
            return value;
        }

        function _replaceParamsOnTranslation(value,params){
            for(var index in params){
                var toFind = '{'+index+'}';
                value = value.split(toFind).join(params[index]);
                value = value.replace('%s', params[index]);
            }
            return value;
        }

        /*
         *  @Param Array
         */
        function _getProperties(ArrayObj) {
            var deferred = $q.defer();
            if(!ArrayObj){
                deferred.reject('ERROR Tienes que enviar parametro ARRAY');
            } else {
                return preCommonCmsSvc.getCmsConfigObj().then(function () {
                    return _getPropertiesOfJsonCache(ArrayObj);
                });
            }
            return deferred.promise;
        }

        function _getPropertiesOfJsonCache(ArrayObj) {
            var deferred = $q.defer();
            var res = [];
            _.each(ArrayObj, function (key) {
                _.each(_this.JsonCacheConf, function (objJson) {
                    if(key === objJson.key){
                        objJson.webApp = JSON.parse(objJson.webApp);
                        res = _.concat(res, objJson);
                    }
                });
            });
            deferred.resolve( res );
            return deferred.promise;
        }

        function _getConfigCmsPage() {
            var cmsPageConfig = {};
            return service.getProperty('apollo_config').then(function(conf){
                if(!conf){
                    return cmsPageConfig;
                }
                if(conf[inditex.iPage]){
                    //debugger
                    // fix para la imantada en IOS
                    // if(conf[inditex.iPage].magnetized){
                    //     $('html').css({ overflow: "hidden" });
                    // }
                    return conf[inditex.iPage];
                } else {
                    return conf['Default'];
                }
            }).catch(function(){
                console.error(`No se ha declarado la variable apollo_config para ${inditex.iPage}`);
            });
        }

        function _isCmsPage() {
            return (inditex && inditex.iPage === 'ItxHomeBgPage' || 
                    inditex && inditex.iPage === 'ItxHomeMenPage' ||
                    inditex && inditex.iPage === 'ItxHomePage' ||
                    inditex && inditex.iPage === 'ItxSearchPage' ||
                    inditex && inditex.iPage === 'ItxSessionExpiredPage' ||
                    inditex && inditex.iPage === 'ItxMassimoDuttiFeelPage' );
        }

    }

})();
